import classNames from 'classnames';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface Props {
  className?: string;
}

export default function ErrorIcon({className}: Props): JSX.Element {
  return <BenchlingIcon icon="revision" className={classNames('u-danger-color', className)} />;
}
